import axios from 'axios';
import QueryString from 'qs';
import { generateQueryParams } from 'utils/generateQueryParams';

export const ServicesService = {
  async getServicesHistory(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('org/v1/clientBoughtService/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async addServiceToClient(data) {
    const res = await axios.post('org/v1/packages_services/client/add/', data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getNewServices({ page, perPage }) {
    const res = await axios.get('org/v1/services/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createNewService(payload) {
    const res = await axios.post('org/v1/services/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteNewService(id) {
    const res = await axios.delete(`org/v1/services/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateService(payload, id) {
    const res = await axios.put(`org/v1/services/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getDiscount({ page, perPage }) {
    const res = await axios.get('org/v1/discountService/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createDiscount(payload) {
    const res = await axios.post('org/v1/discountService/', payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async updateDiscount(payload, id) {
    const res = await axios.put(`org/v1/discountService/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteDiscount(id) {
    const res = await axios.delete(`org/v1/discountService/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getPromocodes(page, perPage, searchQuery) {
    const params = generateQueryParams({
      page,
      size: perPage,
      search: searchQuery,
    });

    const res = await axios.get('payments/v1/promoclients/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getPromos(page, perPage, searchQuery) {
    const params = generateQueryParams({
      page,
      size: perPage,
      search: searchQuery,
    });

    const res = await axios.get('payments/v1/promocodes/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createPromo(payload) {
    const res = await axios.post('payments/v1/promocodes/', payload);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async updatePromo(payload, group) {
    const res = await axios.put(`payments/v1/promocodes/${group}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deletePromo(group) {
    const res = await axios.delete(`payments/v1/promocodes/`, {
      data: { promocodes: [group] },
    });

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getOptions({ page, perPage }) {
    const res = await axios.get('org/v1/options/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getOption(id) {
    const res = await axios.get(`org/v1/options/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async deleteOption(id) {
    const res = await axios.delete(`org/v1/options/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateOption(payload, id) {
    const res = await axios.put(`org/v1/options/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async getPackages({ page, perPage }) {
    const res = await axios.get('org/v1/packages_services/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createPackage(payload) {
    const res = await axios.post('org/v1/packages_services/', payload);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async getPackageById(id) {
    const res = await axios.get(`org/v1/packages_services/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async deletePackage(id) {
    const res = await axios.delete(`org/v1/packages_services/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updatePackage(payload, id) {
    const res = await axios.put(`org/v1/packages_services/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
